import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconChevronLargeTop"><Path fillRule="evenodd" clipRule="evenodd" d="M11.6168 8.10535C11.853 7.96488 12.1472 7.96488 12.3834 8.10535L21.6334 13.6053C21.9895 13.817 22.1065 14.2773 21.8948 14.6333C21.6831 14.9893 21.2228 15.1063 20.8668 14.8947L12.0001 9.62256L3.13342 14.8947C2.77739 15.1063 2.31716 14.9893 2.10546 14.6333C1.89377 14.2773 2.01078 13.817 2.36681 13.6053L11.6168 8.10535Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeTop;
